import React from 'react';
import { T } from '@tolgee/react';
import { TrackingOrder } from '../../Public/OrderTracking/orderTracking.interface';
import LoadingSpinner from '../../../assets/LoadingSpinner';
import { cn } from '../../../lib/utils';

interface TrackingProgressProps {
	order: TrackingOrder;
	className?: string;
}

const TrackingProgress: React.FC<TrackingProgressProps> = ({
	order,
	className,
}) => {
	const vehicles = order.trucks.filter((truck) => !!truck.driverName).length;
	const steps = [
		order.routePending ? (
			<T key="route" keyName="orderPage.loading.route">
				Calculating delivery route…
			</T>
		) : null,
		order.positionsPending && vehicles > 0 ? (
			vehicles > 1 ? (
				<T key="positions" keyName="orderPage.loading.vehiclePositions">
					Retrieving vehicle positions…
				</T>
			) : (
				<T key="position" keyName="orderPage.loading.vehiclePosition">
					Retrieving vehicle position…
				</T>
			)
		) : null,
	].filter(Boolean);

	if (!steps.length) return null;

	return (
		<div
			role="status"
			className={cn(
				'absolute z-[600] flex flex-col gap-2 bg-white border border-solid border-track-line rounded-[10px] px-4 py-3 shadow-[0_2px_12px_rgba(31,31,39,0.08)] text-[13px] text-track-body',
				className,
			)}
		>
			{steps.map((step, index) => (
				<span key={index} className="flex items-center gap-2 whitespace-nowrap">
					<span className="flex text-track-indigo">
						<LoadingSpinner color="current" />
					</span>
					{step}
				</span>
			))}
		</div>
	);
};

export default TrackingProgress;
